//Add strings
gdprCookieNoticeLocales.en = {
  bar_title: "This website uses cookies",
  description:
    "We use cookies to offer you a better browsing experience, personalise content and ads, to provide social media features and to analyse our traffic. Read about how we use cookies and how you can control them by clicking Cookie Settings. You consent to our cookies if you continue to use this website.",
  settings: "Manage Cookies",
  accept: "Accept & Continue",
  save: "Save Changes",
  policy: "Learn more",
  manage: "Manage Cookies",
  always_on: "Always on",
  toggle_button_first: "Cookies",
  toggle_button_second: "Setting",
  cookie_essential_title: "Essential website cookies",
  cookie_essential_desc:
    "Necessary cookies help make a website usable by enabling basic functions like page navigation and access to secure areas of the website. The website cannot function properly without these cookies.",
  cookie_performance_title: "Performance cookies",
  cookie_performance_desc:
    "These cookies are used to enhance the performance and functionality of our websites but are non-essential to their use. For example it stores your preferred language or the region that you are in.",
  cookie_analytics_title: "Analytics cookies",
  cookie_analytics_desc:
    "We use analytics cookies to help us measure how users interact with website content, which helps us customize our websites and application for you in order to enhance your experience.",
  cookie_marketing_title: "Marketing cookies",
  cookie_marketing_desc:
    "These cookies are used to make advertising messages more relevant to you and your interests. The intention is to display ads that are relevant and engaging for the individual user and thereby more valuable for publishers and third party advertisers."
};
